<template>
  <div class="table-freeze-wrapper">
    <table class="table-freeze">
      <thead>
        <tr class="thead-level-1">
          <th rowspan="2" class="sticky-col col-no text-center">No</th>
          <th rowspan="2" class="sticky-col col-kode">Kode Proyek</th>
          <th rowspan="2" class="sticky-col col-nama">Nama Proyek</th>
          <th rowspan="2" class="text-left">Nama Kontrak</th>
          <th rowspan="2" class="text-center">Mekanisme</th>
          <th rowspan="2" class="text-center">Tanggal Mulai</th>
          <th rowspan="2" class="text-center">Tanggal Berakhir</th>
          <th rowspan="2" class="text-right">Nilai Kontrak (Belum PPN)</th>

          <th colspan="3" class="text-center group-header"
            >Rencana Anggaran Biaya (RAB)</th
          >
          <th colspan="3" class="text-center group-header">Panjar & Beban</th>

          <th rowspan="2" class="text-left">Keterangan</th>
          <th rowspan="2" class="text-center">Status Proyek</th>
          <th rowspan="2" class="text-center">Status Dokumen</th>
          <th rowspan="2" class="sticky-col-right col-aksi text-center"
            >Aksi</th
          >
        </tr>

        <tr class="thead-level-2">
          <th class="text-right sub-header">SPH</th>
          <th class="text-right sub-header">SPK</th>
          <th class="text-center sub-header">Margin</th>

          <th class="text-right sub-header">Total Panjar</th>
          <th class="text-right sub-header">Selisih Beban</th>
          <th class="text-center sub-header">Margin Panjar</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(item, index) in items"
          :key="item.id || index"
          :class="{ 'row-hover': hoveredIndex === index }"
          @mouseover="hoveredIndex = index"
          @mouseleave="hoveredIndex = null"
        >
          <td class="sticky-col col-no text-center">
            {{ renderCellValue(item, 'no', index) }}
          </td>

          <td class="sticky-col col-kode font-weight-medium">
            <a
              href="javascript:void(0)"
              class="text-primary text-underline"
              @click="$emit('click-detail', item)"
            >
              {{ renderCellValue(item, 'kode_proyek') }}
            </a>
          </td>

          <td
            class="sticky-col col-nama text-truncate-custom"
            :title="item.nama_proyek"
          >
            {{ renderCellValue(item, 'nama_proyek') }}
          </td>

          <td class="text-left text-truncate-custom" :title="item.nama_kontrak">
            {{ renderCellValue(item, 'nama_kontrak') }}
          </td>

          <td class="text-center">{{
            renderCellValue(item, 'mekanisme_pembayaran')
          }}</td>
          <td class="text-center">{{
            renderCellValue(item, 'tanggal_mulai')
          }}</td>
          <td class="text-center">{{
            renderCellValue(item, 'tanggal_berakhir')
          }}</td>
          <td class="text-right font-weight-bold text-success">
            {{ renderCellValue(item, 'nilai_kontrak_belum_ppn') }}
          </td>

          <td class="text-right">{{ renderCellValue(item, 'sph') }}</td>
          <td class="text-right">{{ renderCellValue(item, 'spk') }}</td>
          <td class="text-center font-weight-medium">{{
            renderCellValue(item, 'margin')
          }}</td>

          <td class="text-right">{{
            renderCellValue(item, 'total_panjar')
          }}</td>
          <td class="text-right">{{
            renderCellValue(item, 'selisih_beban_panjar')
          }}</td>
          <td class="text-center font-weight-medium">{{
            renderCellValue(item, 'margin_beban_panjar')
          }}</td>

          <td class="text-left">{{ item.keterangan || '-' }}</td>

          <td class="text-center">
            <button
              v-if="user.role !== 'ADMINISTRASI'"
              class="btn btn-sm pr-2 pl-2 rounded-0 font-size-11"
              :class="
                item.status_proyek === 'AKTIF'
                  ? 'btn-outline-primary'
                  : 'btn-dark'
              "
              @click="$emit('change-status', item)"
            >
              {{ item.status_proyek }}
            </button>
            <span v-else>{{ item.status_proyek }}</span>
          </td>

          <td class="text-center">
            <a
              href="javascript:void(0)"
              class="btn btn-sm btn-link p-0 font-size-11"
              @click="$emit('click-dokumen', item)"
            >
              {{ getPercentage(item) }}%
            </a>
          </td>

          <td class="sticky-col-right col-aksi text-center">
            <div
              class="d-flex justify-content-center align-items-center style-gap"
            >
              <router-link
                :to="`${routes}/${item.id}/view`"
                class="btn btn-sm btn-outline-primary p-1 d-flex align-items-center justify-content-center"
                title="Lihat Rincian Lengkap"
              >
                <i
                  class="uil uil-eye"
                  style="font-size: 14px; line-height: 11px;"
                ></i>
              </router-link>

              <!-- <button
                v-if="user.role !== 'ADMINISTRASI'"
                class="btn btn-sm btn-outline-danger p-1 d-flex align-items-center justify-content-center"
                title="Hapus Data"
                @click="$emit('remove-data', item.id)"
              >
                <i class="uil uil-trash" style="font-size: 14px;"></i>
              </button> -->
            </div>
          </td>
        </tr>

        <tr v-if="items.length === 0">
          <td colspan="17" class="text-center text-muted py-5">
            Tidak ada data transaksi proyek yang ditemukan.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ProjectTable',
  props: {
    items: { type: Array, default: () => [] },
    dokumens: { type: Array, default: () => [] },
    fields: { type: Array, required: true },
    user: { type: Object, default: () => ({}) },
    routes: { type: String, default: '/web/transaksi/proyek' },
    currentPage: { type: Number, default: 1 },
    perPage: { type: Number, default: 25 },
  },
  data() {
    return {
      hoveredIndex: null,
    }
  },
  methods: {
    renderCellValue(item, key, index) {
      if (key === 'no') {
        return (this.currentPage - 1) * this.perPage + (index + 1)
      }

      // Temukan blueprint formatter dari array fields parent index
      const fieldConfig = this.fields.find((f) => f.key === key)
      if (fieldConfig && typeof fieldConfig.formatter === 'function') {
        return fieldConfig.formatter(item[key], key, item)
      }

      return item[key] !== undefined && item[key] !== null ? item[key] : '-'
    },
    getPercentage(item) {
      let tDokumens = JSON.parse(JSON.stringify(this.dokumens))
      if (item.rab) {
        tDokumens.find((x) => x.tipe === 'RAB').status = true
      }
      if (item.panjar) {
        tDokumens.find((x) => x.tipe === 'PANJAR').status = true
      }
      let dokumens = item.dokumen
      dokumens.forEach((vDokumen) => {
        tDokumens.forEach((sDokumen) => {
          if (vDokumen.tipe === sDokumen.tipe) {
            sDokumen.status = true
          }
        })
      })
      const trueData = tDokumens.filter((x) => x.status === true).length
      const totalData = tDokumens.length
      return Math.round((trueData / totalData) * 100)
    },
  },
}
</script>

<style scoped>
/* Paste baris kode CSS pembeku yang Anda kirimkan utuh di sini */
.table-freeze-wrapper {
  overflow: auto;
  width: 100%;
  max-height: 75vh;
  border: 1px solid #dee2e6;
}
.table-freeze {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 2100px; /* Diperlebar sedikit agar menampung kolom baru tanpa tumpang tindih */
  font-size: 13px;
}
.table-freeze th,
.table-freeze td {
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  padding: 8px 12px;
  white-space: nowrap;
  background: #fff;
  vertical-align: middle;
}
.table-freeze th {
  border-top: 1px solid #dee2e6;
}
.table-freeze th:first-child,
.table-freeze td:first-child {
  border-left: 1px solid #dee2e6;
}
.table-freeze thead th {
  position: sticky;
  background-color: #ffffff;
}
.thead-level-1 th {
  top: 0;
  z-index: 20;
}
.thead-level-2 th {
  top: 37px;
  z-index: 19;
}
.table-freeze thead .group-header {
  background: #e9ecef !important;
  font-weight: 700;
  font-size: 13px;
  text-align: center;
}
.table-freeze thead .sub-header {
  background: #f8f9fa !important;
  font-size: 12px;
  font-weight: 600;
}
.sticky-col {
  position: sticky;
  background: #fff;
  z-index: 10;
}
.thead-level-1 th.sticky-col {
  top: 0;
  z-index: 50;
}
.thead-level-2 th.sticky-col {
  top: 37px;
  z-index: 45;
}

.col-no {
  left: 0;
  width: 50px;
  min-width: 50px;
}
.col-kode {
  left: 50px;
  width: 150px;
  min-width: 150px;
}
.col-nama {
  left: 200px;
  width: 260px;
  min-width: 260px;
  box-shadow: 4px 0 6px -2px rgba(0, 0, 0, 0.08);
}

.sticky-col-right {
  position: sticky;
  right: 0;
  background: #fff;
  z-index: 10;
  box-shadow: -4px 0 6px -2px rgba(0, 0, 0, 0.08);
}
.thead-level-1 th.sticky-col-right {
  top: 0;
  z-index: 50;
}
.thead-level-2 th.sticky-col-right {
  top: 37px;
  z-index: 45;
}

.col-aksi {
  width: 95px;
  min-width: 95px;
}
.style-gap {
  gap: 6px;
}
.text-right {
  text-align: right;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.font-weight-bold {
  font-weight: 700;
}
.font-weight-medium {
  font-weight: 600;
}
.text-success {
  color: #198754;
}
.text-danger {
  color: #dc3545;
}
.text-warning {
  color: #fd7e14;
}
.text-primary {
  color: #0d6efd;
}
.text-underline {
  text-decoration: underline;
  cursor: pointer;
}

.row-hover td,
tr.row-hover .sticky-col,
tr.row-hover .sticky-col-right {
  background-color: #f8f9fa !important;
}
.text-truncate-custom {
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table-freeze-wrapper::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}
.table-freeze-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.table-freeze-wrapper::-webkit-scrollbar-track {
  background: #f8fafc;
}
</style>
